export class DeleteUserSuccess {
    static readonly type = '[User] DeleteUserSuccess';

    constructor(public payload: string) {}
}
